// extracted by mini-css-extract-plugin
export default {"message":"_3oX64mhtq6NIHEE-dJJHh6","alert":"_3v3y3TCPfhwdXu9PGoOnqk","icon":"_2dWsp_oKL084ZuXK7bFu21"};